// Fly-to-cart animacija: klonira sliku proizvoda i "leti" do brojača u bottom baru.
// Ukras — nikad ne sme da sruši dodavanje u korpu, zato je sve u try/catch.
export const flyToCartFromImage = (img) => {
  try {
    const target = document.getElementById("cart-fly-target");
    if (!img || !target) return;

    const from = img.getBoundingClientRect();
    const to = target.getBoundingClientRect();

    const clone = img.cloneNode(true);
    Object.assign(clone.style, {
      position: "fixed",
      left: `${from.left}px`,
      top: `${from.top}px`,
      width: `${from.width}px`,
      height: `${from.height}px`,
      objectFit: "cover",
      borderRadius: "6px",
      zIndex: 9999,
      pointerEvents: "none",
      margin: 0,
      opacity: 1,
      transition: "all 0.8s cubic-bezier(0.22, 0.72, 0.18, 1)",
    });
    document.body.appendChild(clone);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        Object.assign(clone.style, {
          left: `${to.left + to.width / 2 - 12}px`,
          top: `${to.top + to.height / 2 - 12}px`,
          width: "24px",
          height: "24px",
          opacity: "0.25",
          borderRadius: "50%",
        });
      });
    });

    setTimeout(() => {
      clone.remove();
      target.animate(
        [
          { transform: "scale(1)" },
          { transform: "scale(1.7)" },
          { transform: "scale(1)" },
        ],
        { duration: 380, easing: "ease-out" }
      );
    }, 820);
  } catch (_) {
    /* noop */
  }
};
